import React from 'react';
import { SearchFieldWithDebounce } from '@adjust/dashboard-components';
import { connectWithStore } from '@common/connectWithStore';
import { searchAppList } from '@redux/ducks/app/app';

interface SearchAppListDispatchProps {
  searchAppList: (searchTerm?: string) => void;
}

export const SearchAppListComponent: React.FC<SearchAppListDispatchProps> = ({ searchAppList }) => (
  <SearchFieldWithDebounce
    name="app-search"
    placeholder={t('label.search-apps')}
    onChange={searchAppList}
    onReset={() => searchAppList('')}
    wait={300}
  />
);

const mapStateToDispatch = { searchAppList };

export const SearchAppList = connectWithStore(null, mapStateToDispatch)(SearchAppListComponent);
